import React from 'react'
import SearchResultContainer from '../../../Components/Applications/SearchResult'

export default function SearchResult() {
  return (
    <div className='page-body'>
        <SearchResultContainer/>
    </div>
  )
}
